import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { lazy, Suspense } from "react";
import Splash from "../pages/Splash";
import { getHomeRoute } from "../utils/homeRoute";
import DashboardLayout from "../components/layout/DashboardLayout";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useState } from "react";
import AlertModal from "../components/AlertModal";
import { Box } from "@mui/material";

// Route-level code splitting - each page is only fetched when its route is first visited,
// instead of every page (50+ of them) being bundled into the initial load. Splash and
// DashboardLayout stay eager since they're needed immediately on every load.
const LandingPage = lazy(() => import("../pages/Landing"));
const Login = lazy(() => import("../pages/Login"));
const Signup = lazy(() => import("../pages/Signup"));
const OtpVerification = lazy(() => import("../pages/OtpVerification"));
const ParentApproval = lazy(() => import("../pages/ParentApproval"));
const CompleteProfile = lazy(() => import("../pages/CompleteProfile"));
const ParentHome = lazy(() => import("../pages/ParentHome"));
const AddChild = lazy(() => import("../pages/AddChild"));
const ChildDetail = lazy(() => import("../pages/ChildDetail"));
const ForgotPassword = lazy(() => import("../pages/ForgotPassword"));
const FOtpVerification = lazy(() => import("../pages/FOtpVerification"));
const NewPassword = lazy(() => import("../pages/NewPassword"));
const ResetSuccessfull = lazy(() => import("../pages/ResetSuccessfull"));
const Home = lazy(() => import("../pages/Home"));
const Profile = lazy(() => import("../pages/Profile"));
const Library = lazy(() => import("../pages/Library"));
const Draft = lazy(() => import("../pages/Draft"));
const Calendar = lazy(() => import("../pages/Calendar"));
const Teams = lazy(() => import("../pages/Teams"));
const Settings = lazy(() => import("../pages/Settings"));
const ScoreBoard = lazy(() => import("../pages/ScoreBoardComponents/ScoreBoard"));
const EditProfile = lazy(() => import("../pages/EditProfile"));
const ChangePassword = lazy(() => import("../pages/ChangePassword"));
const SubsPage = lazy(() => import("../pages/SubsPage"));
const MyAccessCode = lazy(() => import("../pages/MyAccessCode"));
const ContactUs = lazy(() => import("../pages/ContactUs"));
const FAQ = lazy(() => import("../pages/FAQ"));
const FileView = lazy(() => import("../pages/FileView"));
const AboutUS = lazy(() => import("../pages/AboutUs"));
const Terms = lazy(() => import("../pages/Terms"));
const Notifications = lazy(() => import("../pages/Notifications"));
const ChatPage = lazy(() => import("../pages/Chat"));
const BroadCast = lazy(() => import("../pages/Broadcast"));
const UserDetails = lazy(() => import("../pages/UserDetails"));
const JoinGroup = lazy(() => import("../pages/JoinGroup"));
const CreateGroup = lazy(() => import("../pages/CreateGroup"));
const CreateSubGroup = lazy(() => import("../pages/CreateSubGroup"));
const ManualSubmission = lazy(() => import("../pages/ManualSubmission"));
const FullGroupDetails = lazy(() => import("../pages/FullGroupDetails"));
const SubGroup = lazy(() => import("../pages/SubGroup"));
const Map = lazy(() => import("../pages/Map"));
const Interaction = lazy(() => import("../pages/Interactions"));
const PostingTo = lazy(() => import("../pages/PostingTo"));
const ChooseAccess = lazy(() => import("../pages/ChooseAccess"));
const Post1 = lazy(() => import("../pages/Post1"));
const Post2 = lazy(() => import("../pages/Post2"));
const CommentsPage = lazy(() => import("../pages/CommentsPage"));
const ChatSettings = lazy(() => import("../pages/ChatSettings"));
const PostDetail = lazy(() => import("../pages/PostDetail"));
const Quiz = lazy(() => import("../pages/Quiz"));
const ProfilePoint = lazy(() => import("../pages/ProfilePoint"));
const UserScoreBoard = lazy(() => import("../pages/UserScoreBoard"));
const Quizes = lazy(() => import("../pages/Quizes"));
const Privacy = lazy(() => import("../pages/Privacy"));

const RouteFallback = () => (
    <Box sx={{ height: "100vh", width: "100vw", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <img src="assets/loader1.gif" style={{ height: "40px" }} alt="Loading" />
    </Box>
)

export default function MainRoute() {
    const auth = useSelector(state => state.auth)
    const navigate = useNavigate()
    const location = useLocation()
    const [chatDisabledModal, setChatDisabledModal] = useState(false)
    useEffect(() => {
        const homePath = getHomeRoute(auth?.user)
        if (auth?.authorize) {
            if (!location.pathname?.includes("user")) {
                navigate(homePath, { replace: true })
            } else if (auth?.user?.role == "parent" && location.pathname == "/user/home") {
                navigate("/user/parent-home", { replace: true })
            } else if (auth?.user?.role != "parent" && location.pathname == "/user/parent-home") {
                navigate("/user/home", { replace: true })
            } else if (auth?.user?.chatEnabled == false && (location.pathname == "/user/chat" || location.pathname == "/user/chatSettings")) {
                setChatDisabledModal(true)
                navigate(homePath, { replace: true })
            }
        } else {
            if (location.pathname?.includes("user")) {
                navigate("/", { replace: true })
            }
        }
    }, [location])
    return (
        <>
        <Suspense fallback={<RouteFallback />}>
        <Routes>
            <Route path="/" element={<Splash />} />
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/otp" element={<OtpVerification />} />
            <Route path="/parent-approval" element={<ParentApproval />} />
            <Route path="/complete-profile" element={<CompleteProfile />} />
            <Route path="/forgot" element={<ForgotPassword />} />
            <Route path="/fotp" element={<FOtpVerification />} />
            <Route path="/newp" element={<NewPassword />} />
            <Route path="/success" element={<ResetSuccessfull />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy_policy" element={<Privacy/>} />
            <Route path="/user" element={<DashboardLayout />} >
                <Route path="/user/home" element={<Home />} />
                <Route path="/user/parent-home" element={<ParentHome />} />
                <Route path="/user/add-child" element={<AddChild />} />
                <Route path="/user/child/:id" element={<ChildDetail />} />
                <Route path="/user/profile" element={<Profile />} />
                <Route path="/user/library" element={<Library />} />
                <Route path="/user/draft" element={<Draft />} />
                <Route path="/user/calendar" element={<Calendar />} />
                <Route path="/user/teams" element={<Teams />} />
                <Route path="/user/settings" element={<Settings />} />
                <Route path="/user/scoreboard" element={<ScoreBoard />} />
                <Route path="/user/editProfile" element={<EditProfile />} />
                <Route path="/user/changePassword" element={<ChangePassword />} />
                <Route path="/user/chatSettings" element={<ChatSettings />} />
                <Route path="/user/subs" element={<SubsPage />} />
                <Route path="/user/access" element={<MyAccessCode />} />
                <Route path="/user/contact" element={<ContactUs />} />
                <Route path="/user/faq" element={<FAQ />} />
                <Route path="/user/fileviewer" element={<FileView />} />
                <Route path="/user/aboutUs" element={<AboutUS />} />
                <Route path="/user/terms" element={<Terms />} />
                <Route path="/user/notis" element={<Notifications />} />
                <Route path="/user/chat" element={<ChatPage />} />
                <Route path="/user/broadcast" element={<BroadCast />} />
                <Route path="/user/details" element={<UserDetails />} />
                <Route path="/user/join" element={<JoinGroup />} />
                <Route path="/user/create" element={<CreateGroup />} />
                <Route path="/user/sub" element={<CreateSubGroup />} />
                <Route path="/user/manual" element={<ManualSubmission />} />
                {/* not in navigations */}
                <Route path="/user/group" element={<FullGroupDetails />} />
                <Route path="/user/map" element={<Map />} />
                <Route path="/user/interaction" element={<Interaction />} />
                {/* upto here */}
                <Route path="/user/post1" element={<Post1 />} />
                <Route path="/user/user_score" element={<UserScoreBoard />} />
                <Route path="/user/post2" element={<Post2 />} />
                <Route path="/user/postingTo" element={<PostingTo />} />
                <Route path="/user/choose" element={<ChooseAccess />} />
                <Route path="/user/comments" element={<CommentsPage />} />
                <Route path="/user/quiz" element={<Quiz />} />
                <Route path="/user/subGroup" element={<SubGroup />} />
                <Route path="/user/post_detail" element={<PostDetail />} />
                <Route path="/user/profile_point" element={<ProfilePoint />} />
                {/* saved quizes List */}
                <Route path="/user/quizes" element={<Quizes />} />
            </Route>
        </Routes>
        </Suspense>
        <AlertModal
            open={chatDisabledModal}
            setOpen={setChatDisabledModal}
            title="Chat Disabled"
            message="Your chat feature has been disabled by your parent. Please ask them to enable it from their account."
        />
        </>
    )
}
